/**
 * EnemyAI.ts
 * Enemy decision making. The live simulation can call decide() with a compact
 * battle snapshot and execute the returned commands against enemy units.
 */

import type { Enemy } from '../units/enemies/Enemy';
import type { BattleSnapshot, EnemyCommand } from '../types';
import { BattlePlanner } from './BattlePlanner';

export class EnemyAI {
  private readonly planner = new BattlePlanner();

  update(delta: number, enemies: Enemy[]): void {
    for (const enemy of enemies) enemy.think(delta);
  }

  decide(snapshot: BattleSnapshot): EnemyCommand[] {
    return this.planner.decide(snapshot);
  }
}
